import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

export type ProjectReportsReducerType = {
  month: Nullable<Date>;
  reportType: Nullable<ProjectReportType["reportType"]>;
};

const initialState: ProjectReportsReducerType = {
  month: null,
  reportType: null,
};

const projectReportSlice = createSlice({
  name: "projectReports",
  initialState,
  reducers: {
    setMonth(state, { payload }: PayloadAction<Nullable<Date>>) {
      state.month = payload;
    },

    setReportType(state, { payload }: PayloadAction<Nullable<ProjectReportType["reportType"]>>) {
      state.reportType = payload;
    },

    resetFilters(state) {
      state.month = null;
      state.reportType = null;
    },
  },
});

export const { resetFilters, setMonth, setReportType } = projectReportSlice.actions;
export const projectReportsSelector = (state: RootState) => state.projectReports;
export default projectReportSlice.reducer;
